import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <div className="about-header">
            <span className="section-eyebrow">The Brand</span>
            <h2 className="section-title">
              Prep Meets <span className="highlight">Edge</span>
            </h2>
            <div className="steel-line center"></div>
          </div>

          <div className="about-grid">
            <div className="about-text">
              <p className="lead">
                Slate & Steel is more than a clothing brand — it's a movement for men who 
                refuse to choose between refined and rebellious.
              </p>
              <p>
                We believe the modern man embodies duality: the polish of a boardroom executive 
                and the edge of a motorcycle rider. Think raw selvedge denim paired with 
                premium Oxford cloth. A butter-soft leather jacket over a crisp V-neck sweater. 
                This is <strong>Predgy</strong> — the fusion of prep and edgy that defines 
                our aesthetic.
              </p>
              <p>
                Every piece in our collection is curated for quality craftsmanship and timeless 
                appeal. Full-grain leathers, Japanese selvedge denim, extra-long staple cotton, 
                cashmere blends — we source only materials that age beautifully and tell a story.
              </p>
            </div>

            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">100%</span>
                <span className="stat-label">Quality Focus</span>
                <span className="stat-desc">Premium materials only</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">∞</span>
                <span className="stat-label">Timeless Style</span>
                <span className="stat-desc">Beyond trends</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">2</span>
                <span className="stat-label">Worlds Merged</span>
                <span className="stat-desc">Prep + Edge = Predgy</span>
              </div>
            </div>
          </div>

          <div className="about-pillars">
            <motion.div 
              className="pillar"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="pillar-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <h3>Quality First</h3>
              <p>Full-grain leather, ELS cotton, Japanese selvedge — we never compromise on materials.</p>
            </motion.div>

            <motion.div 
              className="pillar"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="pillar-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
              </div>
              <h3>Timeless Design</h3>
              <p>We curate pieces that transcend seasons and trends — invest once, wear forever.</p>
            </motion.div>

            <motion.div 
              className="pillar"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="pillar-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M12 2v20M2 12h20"/>
                  <path d="M12 2a10 10 0 0 1 10 10"/>
                  <path d="M12 2a10 10 0 0 0-10 10"/>
                </svg>
              </div>
              <h3>Education</h3>
              <p>We teach you to recognize quality and build a wardrobe that commands respect.</p>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Background Accent */}
      <div className="about-bg-accent"></div>
    </section>
  );
};

export default About;





